import { render, staticRenderFns } from "./TranslationCard.vue?vue&type=template&id=46c1ec8e&scoped=true"
import script from "./TranslationCard.vue?vue&type=script&lang=js"
export * from "./TranslationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1ec8e",
  null
  
)

export default component.exports